import { toast } from "react-hot-toast";
import Remote from "../services/network";

export const getDashboardData = async (id) => {
  try {
    const data = await Remote.get("/dashboard/analytics");
    return data?.data?.data;
  } catch (e) {}
};
